import { Contact, deleteContact } from "./api/contact";
import React from "react";
import classes from "./ContactList.module.scss";
import { PrimaryButton } from "../disease_knowledge/components/PrimaryButton";
import classNames from "classnames";
import { RemoveIcon } from "../common/icons/RemoveIcon";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { CheckIcon } from "../common/icons/CheckIcon";
import { WarningIcon } from "../common/icons/WarningIcon";
import { HoverTooltip } from "../common/icons/HoverTooltip";

export function ContactList({ contacts, careRecipient, reloadData, openAddPage }: Props) {

    const onClickDelete = async (id: string, email: string) => {
        if (!careRecipient) return;
        const ok = window.confirm(`${email}を通知先から削除します。よろしいですか？`);
        if (!ok) return;
        await deleteContact(id);
        reloadData();
    };

    return (
        <>
            <div className={classes.header}>
                <div className={classes.description}>
                    以下で設定したメールアドレス宛にアラートの通知が送信されます
                </div>
                <div className={classes.addButton}>
                    <PrimaryButton onClick={openAddPage}>追加</PrimaryButton>
                </div>
            </div>
            <table className={classes.table}>
                <thead>
                    <tr className={classes.tr}>
                        <th className={classes.th}>名前</th>
                        <th className={classes.th}>メールアドレス</th>
                        <th className={classes.th}>ラベル</th>
                        <th className={classes.th}>電話番号1</th>
                        <th className={classes.th}>電話番号2</th>
                        <th className={classes.th}>承認</th>
                        <th className={classes.th}></th>
                    </tr>
                </thead>
                <tbody>
                    {contacts.length === 0 &&
                        <tr className={classes.tr}>
                            <td colSpan={6} className={classNames(classes.td, classes.noData)}>連絡先が登録されていません</td>
                        </tr>
                    }
                    {contacts.map((c) => (
                        <tr className={classes.tr} key={c.id}>
                            <td className={classes.td}>{c.name}</td>
                            <td className={classes.td}>{c.email}</td>
                            <td className={classes.td}>{c.label}</td>
                            <td className={classes.td}>{c.tel1 ?? "-"}</td>
                            <td className={classes.td}>{c.tel2 ?? "-"}</td>
                            <td className={classes.td}>
                                {c.verified ? <CheckIcon /> : <HoverTooltip icon={<WarningIcon />} text={"メールアドレスの持ち主による承認が実行されていません"}/>}
                            </td>
                            <td className={classNames(classes.td, classes.buttons)}>
                                <button onClick={() => onClickDelete(c.id, c.email)}>
                                    <RemoveIcon />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}

type Props = {
    careRecipient: CareRecipientId | null;
    contacts: Contact[];
    reloadData: () => void;
    openAddPage: () => void;
}
